import { render, staticRenderFns } from "./SiderMenuAccordion_deprecated.vue?vue&type=template&id=07c84502&"
import script from "./SiderMenuAccordion_deprecated.vue?vue&type=script&lang=js&"
export * from "./SiderMenuAccordion_deprecated.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports